export const removeMasks = (value: string) => {
    value = value.match(/\d/g)?.join('') ?? '';
    return value;
}